import { Colors } from '@src/colors';
import styled from 'styled-components';
import { Breakpoints } from '../breakpoints';
import { Input } from '../components/form.styled';
import { ValidatedInput } from '../components/validated-input';

export const Terms = styled.p`
    color: white;
    grid-area: terms;
    margin: 0;

    font-family: 'Public Sans';
    font-size: 10px;

    @media print {
        color: ${Colors.midnight};
    }

    > a {
        color: ${Colors.ownerYellow};
    }

    > a:hover {
        color: ${Colors.vacasaYorange};
    }
`;

export const GatherUserDetails = styled.div`
    display: flex;
    flex-direction: column;
    gap: 31px;

    ${Terms} {
        grid-column-start: 1;
        grid-column-end: 4;
        height: 100%;

        @media screen and (max-width: ${Breakpoints.mobile}) {
            grid-column: 1 / span 1;
            grid-row: 6 / span 1;
        }
    }
`;

export const Inputs = styled(Input)`
    display: grid;
    grid-template-areas:
        'first last email phone'
        'terms terms terms submit';

    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;

    column-gap: 10px;
    row-gap: 10px;
    justify-items: center;
    align-items: center;

    @media screen and (max-width: ${Breakpoints.mobile}) {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    & .validated-input {
        font-family: 'Public Sans';

        width: 100%;

        > input {
            height: 55px;
            width: 100%;
        }

        > svg {
            top: 16px !important;
        }

        & .error {
            margin-top: 0 !important;
            margin-left: 0 !important;
            margin: 0 !important;
        }
    }

    & .btn {
        font-family: 'Public Sans';
        font-weight: 800;

        width: 100% !important;

        @media screen and (max-width: ${Breakpoints.mobile}) {
            grid-row: 5 / span 1;
        }
    }
`;

export const FirstName = styled(ValidatedInput)`
    grid-area: first;
`;

export const LastName = styled(ValidatedInput)`
    grid-area: last;
`;

export const Email = styled(ValidatedInput)`
    grid-area: email;
`;

export const Phone = styled(ValidatedInput)`
    grid-area: phone;
`;

export const Submit = styled.div`
    grid-area: submit;
    width: 100%;
`;
